import React, {useContext, useState, useEffect} from 'react';
import {Button, TextField, Typography} from '@material-ui/core'
import DatePicker from "react-datepicker/es";
import "react-datepicker/dist/react-datepicker.css";
import {AppContext} from "../../AppContext";
import {MessageContext} from "../../MessageContext";
import {useHistory, useParams} from "react-router-dom";
import useFormState from '../useFormState';
import moment from 'moment';
import EventAdminNav from "./EventAdminNav";
import {EventBriteFetcher} from "../EventBriteHelper";


export default function AdminEvent() {

    const {eventId} = useParams()
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [name, setName, setNameDirect] = useFormState("")
    const [description, setDescription, setDescriptionDirect] = useFormState("")
    const [startDate, setStartDate] = useState(null)
    const [finishDate, setFinishDate] = useState(null)
    const [timezone, setTimezone] = useState(null)
    const [eventBriteManaged, setEventBriteManaged] = useState(false)
    const [eventBriteLink, setEventBriteLink] = useState(null)


    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/events/${eventId}`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(event => {
                console.log("ADMIN EVENT: ", event)

                setSelectedEvent(event)
                setStartDate(moment(event.start_time).toDate())
                setFinishDate(moment(event.finish_time).toDate())
                setTimezone(event.timezone)
                setNameDirect(event.name)
                setDescriptionDirect(event.description)
                setEventBriteManaged(!!event.eventbrite_id)
            })
    }, [eventId])

    useEffect(() => {
        if(selectedEvent && selectedEvent.eventbrite_id) {
            const ebfetcher = new EventBriteFetcher()
            ebfetcher.fetch(`https://www.eventbriteapi.com/v3/events/${selectedEvent.eventbrite_id}/`)
                .then(response => response.json())
                .then(json => {
                    setEventBriteLink(json.url)
                })
        }
    }, [selectedEvent])

    const context = useContext(AppContext)
    const messageContext = useContext(MessageContext)
    const history = useHistory();
    const displayFormat = 'MMMM Do YYYY, h:mm a'

    const handleSubmit = (e) => {
        e.preventDefault()

        if (name === "") {
            messageContext.showErrorMessage("Please name the event")
        } else if (!moment(startDate).isBefore(moment(finishDate))) {
            messageContext.showErrorMessage("End date has to be later than the start date")
        } else {
            fetch(`${process.env.REACT_APP_API_CALL}/events/${eventId}`, {
                method: "PATCH",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    name: name,
                    description: description,
                    host_user: context.currentUser.id,
                    start_time: startDate,
                    finish_time: finishDate,
                    timezone: timezone,
                })
            })
                .then(response => response.json())
                .then(response => {
                    if (response.errors) {
                        messageContext.showErrorMessage(response.errors)
                    } else {
                        messageContext.showSuccessMessage("Event has been updated")
                        history.push("/admin_home")
                    }
                })
        }
    }

    return (
        <div>

            {selectedEvent ?

                <>
                    <EventAdminNav event={selectedEvent}/>

                    {!eventBriteManaged ?
                        <form onSubmit={handleSubmit} className="create-event-body">

                            <div id="create-event-left">
                                <Typography>Editing </Typography>
                                <div className="new-event-field">
                                    <p>Event Name</p>
                                    <TextField id="name" name="name" value={name} onChange={setName}
                                               disabled={eventBriteManaged}/>
                                </div>

                                <div className="new-event-field">
                                    <p>Event Description</p>
                                    <TextField id="description" name="description" multiline={true} value={description}
                                               onChange={setDescription}
                                               disabled={eventBriteManaged}/>
                                </div>

                                <br/>
                                <Button onClick={() => {
                                    history.push("/admin_home")
                                }} variant="contained" color="secondary">Cancel</Button>
                                <Button type="submit" id="create-event-button" variant="contained" color="primary"
                                        disabled={eventBriteManaged}>Update
                                    Event</Button>
                            </div>

                            <div id="create-event-right">
                                <div className="new-event-field">
                                    <p>Start Date and Time</p>
                                    <DatePicker disabled={eventBriteManaged} selected={startDate} onChange={(date) => setStartDate(date)} showTimeSelect
                                                timeFormat="HH:mm" timeIntervals={15} timeCaption="time"
                                                dateFormat="MMMM d, yyyy h:mm aa"/>
                                </div>

                                <div className="new-event-field">
                                    <p>Finish Date and Time</p>
                                    <DatePicker disabled={eventBriteManaged} selected={finishDate} onChange={(date) => setFinishDate(date)}
                                                showTimeSelect timeFormat="HH:mm" timeIntervals={15} timeCaption="time"
                                                dateFormat="MMMM d, yyyy h:mm aa"/>
                                </div>

                                <div className="new-event-field">
                                    <p>Timezone of the event</p>
                                    <select disabled={eventBriteManaged} value={timezone} onChange={(event) => setTimezone(event.target.value)}>
                                        <option value="est">Eastern</option>
                                        <option value="cst">Central</option>
                                        <option value="mst">Mountain</option>
                                        <option value="pst">Pacific</option>
                                    </select>

                                </div>
                            </div>

                        </form>
                        :
                        <div>
                            <Typography variant="h3"><i>Event detail managed by EventBrite</i></Typography>

                            {eventBriteLink &&
                            <p>
                                <a className="detail-link" href={eventBriteLink}>{eventBriteLink}</a>
                            </p>
                            }

                            <div id="create-event-left">
                                <div className="new-event-field">
                                    <p>Event Name</p>
                                    <p>{name}</p>
                                </div>

                                <div className="new-event-field">
                                    <p>Event Description</p>
                                    <p>{description}</p>
                                </div>
                            </div>

                            <div id="create-event-right">
                                <div className="new-event-field">
                                    <p>Start Date and Time</p>
                                    <p>{moment(startDate).format(displayFormat)}</p>
                                </div>

                                <div className="new-event-field">
                                    <p>Finish Date and Time</p>
                                    <p>{moment(finishDate).format(displayFormat)}</p>
                                </div>

                                <div className="new-event-field">
                                    <p>Timezone of the event</p>
                                    <p>{timezone}</p>
                                </div>
                            </div>
                        </div>
                    }
                </> : null

            }

        </div>
    )

}
